module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Bosworth-Independent-College-bae362c9a8bc5a508865fbdfa81da3aa.jpg";